module.exports = __webpack_public_path__ + "img/yw2.d58721b8.png";